import {
    ALL_IMAGE_MIME_TYPE,
    IMAGE_JPEG_MIME_TYPE,
    IMAGE_PNG_MIME_TYPE,
    PDF_MIME_TYPE
} from '../constants/MimeTypeConstants';

export const uniqueID = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const formatBytes = (bytes, decimals = 0) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const getNextIndex = (array, index) => {
    if (array.length) {
        if (index + 1 === array.length) {
            return 0;
        }
        return index + 1;
    }
    return 0;
};

export const getPreviousIndex = (array, index) => {
    if (array.length) {
        if (index === 0) {
            return array.length - 1;
        }
        return index - 1;
    }
    return 0;
};

export const downloadFileFromURL = (url, name = 'file', type = ALL_IMAGE_MIME_TYPE) => {
    return fetch(
        url,
        {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache'
        }).then(res => res.blob()).then((blob) => {
            const anchor = document.createElement('a');
            const url = window.URL.createObjectURL(new Blob([blob], { type }));
            anchor.href = url;
            anchor.download = name;
            anchor.click();
            window.URL.revokeObjectURL(url);
        }
        );
};

export const downloadFileFromBase64 = (file: string, fileName: string, type: string) => {
    const linkSource = `data:${type};base64,${file}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};

export const scrollToUtil = (element: Element, toRight: boolean): void => {
    const start = element.scrollLeft;
    const increment = 120;
    element.scrollLeft = toRight ? start + increment : start - increment;
};

export const getFileMimeTypeFromURL = (url: string) => url.includes('png') ? IMAGE_PNG_MIME_TYPE :
    (url.includes('jpg') || url.includes('jpeg')) ? IMAGE_JPEG_MIME_TYPE :
        (url.includes('pdf')) ? PDF_MIME_TYPE : ALL_IMAGE_MIME_TYPE;

export const getSafe = (fn) => {
    try {
        return fn();
    } catch (e) {
        return undefined;
    }
};
